<mat-expansion-panel [expanded]="!advice.valid">
  <mat-expansion-panel-header>
    <mat-panel-title>
      @if (!advice.valid) {
        <span>Så här väljer {{ plrDuNi.toLowerCase() }} att göra med mina råd</span>
      } @else {
        <span>{{ advice.value }}</span>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div [class]="{'disable-click-events': controlService.locked()}">
    @if (showOptions) {
      <mat-radio-group (change)="approve($event)"
                       [formControl]="advice"
                       aria-label="Hur vill du göra med mina råd?"
      >
        <mat-radio-button
          value="{{plrDuNi}} väljer att följa mina råd">{{ plrDuNi }} väljer att
          följa mina råd
        </mat-radio-button>
        <mat-radio-button
          value="{{plrDuNi}} väljer att inte följa mina råd">{{ plrDuNi }}
          väljer att inte följa mina råd
        </mat-radio-button>
      </mat-radio-group>
    }
  </div>
</mat-expansion-panel>
